export default __webpack_public_path__ + "static/media/slider2-img-3.5b4ba2d0.svg";